export const GaugeChartDummyData = {
  2025: {
    datasets: [
      {
        value: 70,
        // 区切り点
        // 30-31,40-41のような区間が出るのはchartjsの仕様上防げない
        // その場合0-30区間と同一定義（ラベル・色）とする
        data: [0, 10, 11, 25, 26, 40, 41, 55, 56, 70, 71, 85, 86, 100],
        backgroundColor: [
          "#676767",
          "#676767",
          "#8e1414",
          "#8e1414",
          "#ff0000",
          "#ff0000",
          "#fd7cee",
          "#fd7cee",
          "#ffc000",
          "#ffc000",
          "#74d81d",
          "#74d81d",
          "#019532"
        ],
        labels: [
          "Failed",
          "Failed",
          "Serious",
          "Serious",
          "Very Poor",
          "Very Poor",
          "Poor",
          "Poor",
          "Fair",
          "Fair",
          "Satisfactory",
          "Satisfactory",
          "Good"
        ],
        borderWidth: 0,
        label: "",
      },
    ],
  },
  2026: {
    datasets: [
      {
        value: 66,
        // 区切り点
        // 30-31,40-41のような区間が出るのはchartjsの仕様上防げない
        // その場合0-30区間と同一定義（ラベル・色）とする
        data: [0, 10, 11, 25, 26, 40, 41, 55, 56, 70, 71, 85, 86, 100],
        backgroundColor: [
          "#676767",
          "#676767",
          "#8e1414",
          "#8e1414",
          "#ff0000",
          "#ff0000",
          "#fd7cee",
          "#fd7cee",
          "#ffc000",
          "#ffc000",
          "#74d81d",
          "#74d81d",
          "#019532"
        ],
        labels: [
          "Failed",
          "Failed",
          "Serious",
          "Serious",
          "Very Poor",
          "Very Poor",
          "Poor",
          "Poor",
          "Fair",
          "Fair",
          "Satisfactory",
          "Satisfactory",
          "Good"
        ],
        borderWidth: 0,
        label: "",
      },
    ],
  },
  2027: {
    datasets: [
      {
        value: 60,
        // 区切り点
        // 30-31,40-41のような区間が出るのはchartjsの仕様上防げない
        // その場合0-30区間と同一定義（ラベル・色）とする
        data: [0, 10, 11, 25, 26, 40, 41, 55, 56, 70, 71, 85, 86, 100],
        backgroundColor: [
          "#676767",
          "#676767",
          "#8e1414",
          "#8e1414",
          "#ff0000",
          "#ff0000",
          "#fd7cee",
          "#fd7cee",
          "#ffc000",
          "#ffc000",
          "#74d81d",
          "#74d81d",
          "#019532"
        ],
        labels: [
          "Failed",
          "Failed",
          "Serious",
          "Serious",
          "Very Poor",
          "Very Poor",
          "Poor",
          "Poor",
          "Fair",
          "Fair",
          "Satisfactory",
          "Satisfactory",
          "Good"
        ],
        borderWidth: 0,
        label: "",
      },
    ],
  },
  2028: {
    datasets: [
      {
        value: 55,
        // 区切り点
        // 30-31,40-41のような区間が出るのはchartjsの仕様上防げない
        // その場合0-30区間と同一定義（ラベル・色）とする
        data: [0, 10, 11, 25, 26, 40, 41, 55, 56, 70, 71, 85, 86, 100],
        backgroundColor: [
          "#676767",
          "#676767",
          "#8e1414",
          "#8e1414",
          "#ff0000",
          "#ff0000",
          "#fd7cee",
          "#fd7cee",
          "#ffc000",
          "#ffc000",
          "#74d81d",
          "#74d81d",
          "#019532"
        ],
        labels: [
          "Failed",
          "Failed",
          "Serious",
          "Serious",
          "Very Poor",
          "Very Poor",
          "Poor",
          "Poor",
          "Fair",
          "Fair",
          "Satisfactory",
          "Satisfactory",
          "Good"
        ],
        borderWidth: 0,
        label: "",
      },
    ],
  },
};

export const PieChartDummyData = {
  2025: {
    labels: [
      "Good",
      "Satisfactory",
      "Fair",
      "Poor",
      "Very Poor",
      "Serious",
      "Failed",
    ],
    datasets: [
      {
        data: [29, 24, 23, 20, 4, 0, 0],
        subData: [14.4, 11.9, 11.4, 9.9, 2.0, 0.0, 0.0],
        backgroundColor: [
          "#019532",
          "#74d81d",
          "#ffc000",
          "#fd7cee",
          "#ff0000",
          "#8e1414",
          "#676767"
        ],
        borderWidth: 1,
        unit: "mi",
      },
    ],
  },
  2026: {
    labels: [
      "Good",
      "Satisfactory",
      "Fair",
      "Poor",
      "Very Poor",
      "Serious",
      "Failed",
    ],
    datasets: [
      {
        data: [21, 25, 22, 22, 7, 3, 0],
        subData: [10.4, 12.4, 10.9, 10.9, 3.5, 1.5, 0.0],
        backgroundColor: [
          "#019532",
          "#74d81d",
          "#ffc000",
          "#fd7cee",
          "#ff0000",
          "#8e1414",
          "#676767"
        ],
        borderWidth: 1,
        unit: "mi",
      },
    ],
  },
  2027: {
    labels: [
      "Good",
      "Satisfactory",
      "Fair",
      "Poor",
      "Very Poor",
      "Serious",
      "Failed",
    ],
    datasets: [
      {
        data: [15, 25, 19, 17, 18, 3, 3],
        subData: [7.5, 12.4, 9.4, 8.5, 8.9, 1.5, 1.5],
        backgroundColor: [
          "#019532",
          "#74d81d",
          "#ffc000",
          "#fd7cee",
          "#ff0000",
          "#8e1414",
          "#676767"
        ],
        borderWidth: 1,
        unit: "mi",
      },
    ],
  },
  2028: {
    labels: [
      "Good",
      "Satisfactory",
      "Fair",
      "Poor",
      "Very Poor",
      "Serious",
      "Failed",
    ],
    datasets: [
      {
        data: [10, 19, 24, 15, 14, 12, 6],
        subData: [5.0, 9.4, 11.9, 7.5, 7.0, 6.0, 3.0],
        backgroundColor: [
          "#019532",
          "#74d81d",
          "#ffc000",
          "#fd7cee",
          "#ff0000",
          "#8e1414",
          "#676767"
        ],
        borderWidth: 1,
        unit: "mi",
      },
    ],
  },
};
